<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <assign-memos-admin>
            </assign-memos-admin>
            </div>
        </div>  
        </div>  
    </div>
    </template>
    <script>
    /* eslint-disable */
    import AssignMemosAdmin from './todo-assign-memos-admin'
    export default {
        components: {
            AssignMemosAdmin
        }
    }
    </script>
    <style lang="scss">
        .f-border{
            border-radius: 0px;
        }
        .border-profile-info{
            border:1px #666 dashed;
        }
        .text-right{
            float: right;
            margin-top:7px; 
        }
        .title-header{
            float: right;
            margin-top:7px; 
            font-size: 22px;
            color: #666;
            font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
        }
        .employee_name{
            margin-top:3px;
            font-size: 20px;
        }
        .position_name{
            font-size: 18px;
        }
        .employee_info{
            font-size: 16px;
        }
        .image-pic{
            /* float: right; */
            border:1px solid #ebebeb;
            width:  150px;
            height: 150px;
            /* border-radius:70px;  */
        }
       
         .p-text{
             color:#666;
         }
        
         /* FILE UPLOAD BUTTON  */
         .upload-btn-wrapper {
            position: relative;
            overflow: hidden;
            display: inline-block;
            
          }
        
         .button {
            border: 1px solid gray;
            color: gray;
            background-color: white;
            padding: 5px 13px;
            /* border-radius: 8px; */
            /* font-size: 20px; */
            font-weight: bold;
         }

         .upload-btn-wrapper input[type=file] {
            font-size: 27px;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
           
          }
          .pointer{
              cursor: pointer;
          }
         
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-admin.vue